module.exports = __webpack_public_path__ + "static/media/minus.70f49752.svg";